import React, { useState } from "react";
import { Table, message } from "antd";
import moment from "moment";
import LedgerModal from "../../Ledger/LedgerModal";
import VehicleName from "../../../VehicleName";

export default function VehicleSaleInvoiceTable(props) {
  const { dataSource, onModify, modifyAccess, printAccess, pagination } = props;
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerLedgerOpen, setCustomerLedgerOpen] = useState(false);

  const columns = [
    {
      title: "Invoice No.",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
    },
    {
      title: "Invoice Date",
      dataIndex: "date",
      key: "date",
      render: (date) => (date ? moment(date).format("DD-MM-YYYY") : ""),
    },
    {
      title: "Vehicle Model",
      dataIndex: "vehicleModel",
      key: "vehicleModel",
      width: 260,
      render: (text) => <VehicleName nameOnly modelName={text} />,
    },
    {
      title: "Customer",
      dataIndex: ["party", "name"],
      key: "customer",
      render: (text, record) => {
        const customerObj = record.party || record.customer || record.saleRegister?.customer;
        const custName = record.party?.name || record.customer?.name || text || "-";
        return (
          <span
            className="linkylink"
            onClick={(e) => {
              e.stopPropagation();
              if (customerObj) {
                setSelectedCustomer(customerObj);
                setCustomerLedgerOpen(true);
              }
            }}
          >
            {custName}
          </span>
        );
      },
    },
    {
      title: "Chassis Number",
      dataIndex: "chassisNumber",
      key: "chassisNumber",
    },
    {
      title: "Payment Type",
      dataIndex: "modeType",
      key: "modeType",
      render: (text, row) => {
        if (text?.toLowerCase() === "finance") {
          const hypo =
            row?.saleRegister?.saleData?.loan ? row?.saleRegister?.saleData?.loan.hypothecation :
              row?.hypothecation;

          if (hypo === false) return "Finance No HP";
          if (hypo === true) return "Finance";
          return "Finance";
        }

        return text
          ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
          : "-";
      },
    },
    {
      title: "Net Amount",
      dataIndex: "net",
      key: "net",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {printAccess && (
            <span
              className="linkylink"
              onClick={(e) => {
                e.stopPropagation();
                if (!record.pdf) {
                  message.warn("No invoice for this sale regiser found");
                  return;
                }
                window.open(record.pdf, "_blank", "noopener,noreferrer");
              }}
            >
              Print
            </span>
          )}
        </>
      ),
    },
  ];

  return (
    <div>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        tableLayout="auto"
        dataSource={dataSource}
        pagination={pagination}
      />

      {customerLedgerOpen && selectedCustomer && (
        <LedgerModal
          visible={customerLedgerOpen}
          onCancel={() => {
            setCustomerLedgerOpen(false);
            setSelectedCustomer(null);
          }}
          data={selectedCustomer}
          type="CUSTOMERS"
          initialSubTab="BOOKING_REGISTER"
        />
      )}
    </div>
  );
}
